import airkeyDownloadIllustrationDarkMode from '../../../../assets/airkey-download-illustration-dark-mode.svg';
import airKeyDownloadIllustrationLightMode from '../../../../assets/airkey-download-illustration-light-mode.svg';
import { useTheme } from '../../../../contexts/useTheme';
import { DownloadHomeDescription } from '../DownloadHomeDescription';
import './DownloadHomeInfo.scss';

export const DownloadHomeInfo = () => {
  const { theme } = useTheme();

  const airkeyDownloadIllustration =
    theme === 'dark'
      ? airkeyDownloadIllustrationDarkMode
      : airKeyDownloadIllustrationLightMode;

  return (
    <div className="download-home-info">
      <DownloadHomeDescription />
      <img
        className="download-home-info__image"
        src={airkeyDownloadIllustration}
        alt="Download Image"
      />
    </div>
  );
};
